import { ReactNode } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../hooks';
import { getAccessToken, initAuthentication, selectValidAccessToken } from '../../store/authentication';
import { AuthenticationWrapper, PARAM_CODE, PARAM_STATE } from '../AuthenticationWrapper';

type Props = {
    children: ReactNode;
    autoLogin: boolean;
};

/**
 * This component will make sure that there is a proper authentication before rendering its children.
 * If the user has not authenticated they will be presented with a login button.
 */
const Authenticator = ({ children, autoLogin }: Props) => {
    const dispatch = useAppDispatch();
    const [params] = useSearchParams();
    const accessToken = useAppSelector(selectValidAccessToken);

    const dispatchGetAccessToken = () =>
        dispatch(
            getAccessToken({
                state: params.get(PARAM_STATE)!,
                code: params.get(PARAM_CODE)!,
            }),
        );
    const dispatchInitAuthentication = () => {
        dispatch(initAuthentication());
    };

    return (
        <AuthenticationWrapper
            accessToken={accessToken}
            autoLogin={autoLogin}
            dispatchInitAuthentication={dispatchInitAuthentication}
            dispatchGetAccessToken={dispatchGetAccessToken}>
            {children}
        </AuthenticationWrapper>
    );
};

export default Authenticator;
